module.exports = __webpack_public_path__ + "static/img/banner.69744ee4.png";